/**
 * @sw-package inventory
 */
import AdvancedSearchWidgetPlugin from './plugin/header/advanced-search-widget.plugin';

declare var window: StorefrontWindow;

const PluginManager = window.PluginManager;

PluginManager.register('AdvancedSearchWidgetPlugin', AdvancedSearchWidgetPlugin, '[data-search-widget]');

if (module.hot) {
    module.hot.accept();
}
